(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('mobile-product-purchase')) {
    customElements.define('mobile-product-purchase', class extends HTMLElement {
      connectedCallback() {
        this.bar = this.closest('product-sticky-bar');
        this.form = document.getElementById(this.getAttribute('form'));
        this.primaryButton = this.form?.querySelector('button[type="submit"]');
        this.productInfo = this.form?.closest('.product-info');
        this.footer = document.querySelector('.shopify-section--footer');
        this.restockButton = this.bar?.querySelector('[data-restock-trigger]');
        if (!this.bar || !this.primaryButton) return;

        this.abortController = new AbortController();
        this.mobile = matchMedia('(max-width: 699px)');
        this.updateVisibility = () => {
          const action = this.restockButton ? this.restockSource : this.primaryButton;
          const buttonRect = action?.getBoundingClientRect();
          const barHeight = this.bar.getBoundingClientRect().height;
          const consentHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tokushu-consent-height')) || 0;
          const visibleHeight = window.innerHeight - barHeight - consentHeight;
          const primaryVisible = buttonRect && buttonRect.top >= 0 && buttonRect.bottom <= visibleHeight;
          const footerVisible = this.footer && this.footer.getBoundingClientRect().top < window.innerHeight;
          this.bar.classList.toggle('is-mobile-visible', !!action && this.mobile.matches && !primaryVisible && !footerVisible && !this.restockModalOpen());
        };

        this.modalObserver = new MutationObserver(() => {
          this.updateVisibility();
          if (this.openedFromSticky && !this.restockModalOpen()) {
            this.openedFromSticky = false;
            if (this.bar.classList.contains('is-mobile-visible')) this.restockButton?.focus({preventScroll: true});
          }
        });

        this.refreshObserver = () => {
          this.observer?.disconnect();
          this.restockSource = this.findRestockSource();
          if (this.restockButton) this.restockButton.disabled = !this.restockSource;
          const modal = document.getElementById('gw-stock-fulfilled-iframe');
          if (modal !== this.restockModal) {
            this.modalObserver.disconnect();
            this.restockModal = modal;
            if (modal) this.modalObserver.observe(modal, {attributes: true, attributeFilter: ['style', 'class', 'hidden']});
          }
          const consentHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tokushu-consent-height')) || 0;
          this.observer = new IntersectionObserver(this.updateVisibility, {
            rootMargin: '0px 0px -' + Math.ceil(this.bar.getBoundingClientRect().height + consentHeight) + 'px 0px',
            threshold: [0, 1]
          });
          this.observer.observe(this.restockSource || this.primaryButton);
          if (this.footer) this.observer.observe(this.footer);
          this.updateVisibility();
        };

        this.scheduleRefresh = () => {
          if (this.refreshFrame) return;
          this.refreshFrame = requestAnimationFrame(() => {
            this.refreshFrame = null;
            if (this.isConnected) this.refreshObserver();
          });
        };
        this.mobile.addEventListener('change', this.scheduleRefresh, {signal: this.abortController.signal});
        window.addEventListener('resize', this.scheduleRefresh, {signal: this.abortController.signal});
        document.addEventListener('tokushu:consent-layout', this.scheduleRefresh, {signal: this.abortController.signal});
        this.form.addEventListener('change', this.scheduleRefresh, {signal: this.abortController.signal});
        this.form.addEventListener('variant:change', this.scheduleRefresh, {signal: this.abortController.signal});
        this.barObserver = new ResizeObserver(this.scheduleRefresh);
        this.barObserver.observe(this.bar);

        if (this.restockButton && this.productInfo) {
          this.appObserver = new MutationObserver(this.scheduleRefresh);
          this.appObserver.observe(this.productInfo, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-product-id', 'data-variant-id', 'disabled', 'style', 'class']});
          this.appObserver.observe(document.body, {childList: true});
          this.restockButton.addEventListener('click', () => {
            const source = this.findRestockSource();
            if (!source) {
              this.refreshObserver();
              return;
            }
            this.openedFromSticky = true;
            source.click();
            this.scheduleRefresh();
          }, {signal: this.abortController.signal});
        }

        this.querySelector('[data-view-product-options]')?.addEventListener('click', () => {
          const picker = this.productInfo?.querySelector('variant-picker');
          if (!picker) return;
          picker.setAttribute('tabindex', '-1');
          picker.focus({preventScroll: true});
          picker.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
        }, {signal: this.abortController.signal});
        this.refreshObserver();
      }

      findRestockSource() {
        if (!this.restockButton || !this.productInfo) return null;
        const variantId = this.getAttribute('variant-id');
        if (String(this.form.elements.namedItem('id')?.value) !== variantId) return null;
        return Array.from(this.productInfo.querySelectorAll('.gw-button-widget')).find(button =>
          button.dataset.productId === this.getAttribute('product-id') &&
          button.dataset.variantId === variantId &&
          !button.disabled && button.getClientRects().length > 0 && getComputedStyle(button).visibility !== 'hidden'
        ) || null;
      }

      restockModalOpen() {
        return !!this.restockModal && getComputedStyle(this.restockModal).display !== 'none' && getComputedStyle(this.restockModal).visibility !== 'hidden';
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.appObserver?.disconnect();
        this.modalObserver?.disconnect();
        this.barObserver?.disconnect();
        this.abortController?.abort();
        if (this.refreshFrame) cancelAnimationFrame(this.refreshFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
